<template>
    <div class="container my-5">
      <div class="row">
        <div class="col-12">
          <h1>Métodos Power</h1>
        </div>
        <div class="col-12 my-5">
            <h2>Método 1: adicionar exceções CNPJ</h2>
          <form @submit.prevent="submitCnpj">
            <label for="inserircnpj">Inserir o CNPJ para exceção temporária</label>
            <input id="inserircnpj" :value="formattedCnpj" @input="formatAndSetCnpj" placeholder="Digite o CNPJ" />
            <button type="submit">Enviar</button>
          </form>
        </div>
        <div class="col-12">
          <table border="1" class="table w-100">
            <thead>
              <tr>
                <th>CID</th>
                <th>CNPJ</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record in records" :key="record.cid">
                <td>{{ record.cid }}</td>
                <td>{{ record.cnpj }}</td>
                <td><button @click="deleteRecord(record.cid)">Deletar</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  
  const records = ref([]);
  const rawCnpj = ref('');
  const formattedCnpj = ref('');
  
  const fetchRecords = async () => {
    try {
      const response = await axios.get('https://museucatavento.org.br/sistema-agendamento/apipower.php');
      records.value = response.data;
    } catch (error) {
      console.error('Erro ao buscar registros:', error);
    }
  };
  
  onMounted(fetchRecords);
  
  const formatAndSetCnpj = (event) => {
    const value = event.target.value.replace(/\D/g, '');
    if (value.length <= 14) {
      rawCnpj.value = value;
      formattedCnpj.value = formatCnpj(value);
    }
  };
  
  const formatCnpj = (cnpj) => {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, (match, p1, p2, p3, p4, p5) => `${p1}.${p2}.${p3}/${p4}-${p5}`);
  };
  
  const submitCnpj = async () => {
    try {
      const response = await axios.post('https://museucatavento.org.br/sistema-agendamento/apipower.php', { cnpj: formattedCnpj.value });
      console.log('CNPJ enviado com sucesso, anote o código:', response.data);
      fetchRecords(); // Atualiza a lista após inserção
    } catch (error) {
      console.error('Erro ao enviar CNPJ:', error);
    }
  };
  
  const deleteRecord = async (cid) => {
    try {
      const response = await axios.delete(`https://museucatavento.org.br/sistema-agendamento/apipower.php?cid=${cid}`);
      console.log('Registro deletado com sucesso:', response.data);
      fetchRecords(); // Atualiza a lista após deleção
    } catch (error) {
      console.error('Erro ao deletar registro:', error);
    }
  };
  </script>
  